exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.menu-wrapper i{margin-right:6px\n}\n.menu-wrapper .el-menu-item *,.menu-wrapper .el-submenu__title *{font-size:14px\n}\n.menu-wrapper .router-link-active{background-color:#000\n}\n", "", {"version":3,"sources":["/opt/fh-web/firmiana-hpc-website-main/src/views/firmiana/layout/SidebarItem.vue"],"names":[],"mappings":";AACA,gBAAgB,gBAAgB;CAC/B;AACD,iEAAiE,cAAc;CAC9E;AACD,kCAAkC,qBAAqB;CACtD","file":"SidebarItem.vue","sourcesContent":["\n.menu-wrapper i{margin-right:6px\n}\n.menu-wrapper .el-menu-item *,.menu-wrapper .el-submenu__title *{font-size:14px\n}\n.menu-wrapper .router-link-active{background-color:#000\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d18c3154","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/firmiana/layout/SidebarItem.vue
// module id = 3B0i
// module chunks = 148